import { createContext } from 'react';

interface AgentModeContextType {
  openAIPage: (type: string, agent?: any, backHandler?: () => void) => void;
}

export const AgentModeContext = createContext<AgentModeContextType>({
  openAIPage: () => {},
});
